import { useState, useEffect } from 'react';

export const useSubdomain = () => {
  const [subdomain, setSubdomain] = useState<string>('');
  const [isMainDomain, setIsMainDomain] = useState<boolean>(true);

  useEffect(() => {
    const detectSubdomain = () => {
      const hostname = window.location.hostname;
      const parts = hostname.split('.');

      console.log('[useSubdomain] Detecting subdomain...', {
        hostname,
        search: window.location.search
      });

      // PRIORITY 1: Check for tenant query parameter (works in both dev and production)
      const urlParams = new URLSearchParams(window.location.search);
      const tenant = urlParams.get('tenant');
      console.log('[useSubdomain] Tenant param from URL:', tenant);

      if (tenant) {
        console.log('[useSubdomain] Setting subdomain to tenant param:', tenant);
        setSubdomain(tenant);
        setIsMainDomain(false);
        return;
      }

      // PRIORITY 2: Extract subdomain from hostname (production only)
      if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
        if (parts.length > 2) {
          const sub = parts[0];
          if (sub && sub !== 'www') {
            console.log('[useSubdomain] Production subdomain detected:', sub);
            setSubdomain(sub);
            setIsMainDomain(false);
            return;
          }
        }
      }

      // PRIORITY 3: Default to main domain
      console.log('[useSubdomain] No tenant or subdomain found, setting to main domain');
      setSubdomain('');
      setIsMainDomain(true);
    };

    detectSubdomain();

    // Re-run when URL changes (for development navigation)
    const handleLocationChange = () => {
      console.log('[useSubdomain] Location changed, re-detecting subdomain');
      detectSubdomain();
    };

    window.addEventListener('popstate', handleLocationChange);
    return () => window.removeEventListener('popstate', handleLocationChange);
  }, []);

  return { subdomain, isMainDomain };
};